import Extension from "../base/extension";
import Stencil from "../stencil";

class Nav extends Extension {
  #section;

  data = {
    selectors: {
      navOffcanvas: ".offcanvas",
      navOffcanvasContent: ".nav-offcanvas-content"
    }
  }

  constructor(name) {
    super(name);
  }

  init() {
    this.#section = document.querySelector('.section-header-metaobjects');
    this.setupScrollListener();
    document.addEventListener('interaction:down-scroll', this.onScrollDown.bind(this));
    document.addEventListener('interaction:up-scroll', this.onScrollUp.bind(this));
  }

    /* Added a check to change the offcanvas menu size  adjustment for mobile devices only
   * Solves the issue with testing when people switched from desktop to mobile
   * and the offcanvas menu was still the desktop size.
  */
  onReady() {
    const setOffcanvasWidth = () => {
      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      if (!isMobile) return;

      const offcanvas = document.querySelector(this.data.selectors.navOffcanvas);
      if (!offcanvas) return;

      const offcanvasWidth = offcanvas.getBoundingClientRect().width;
      document.querySelectorAll(this.data.selectors.navOffcanvasContent).forEach(e => {
        e.style.width = `${offcanvasWidth}px`;
      });
    };

    setOffcanvasWidth();

    window.addEventListener("resize", setOffcanvasWidth);
  }

  onScrollDown(e) {
    // if (e.detail.difference > 5) {
    //   this.#section.classList.remove('scrolled-up');
    //   this.#section.classList.add('scrolled-down');
    // }
  }

  onScrollUp(e) {
    // if (e.detail.difference > 5) {
    //   this.#section.classList.remove('scrolled-down');
    //   this.#section.classList.add('scrolled-up');
    // }
  }

  setupScrollListener() {
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (Stencil.isHomePage()) {
      // console.log(Stencil.isHomePage());
      window.addEventListener("scroll", function () {
        let st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

        if (st > 100) {
          document.getElementById('navbar').classList.add('out-of-viewport');
          document.getElementById('navbar').classList.remove('in-viewport');
          /*document.getElementById('navbar').classList.add('bg-white');
          document.getElementById('navbar').classList.remove('bg-transparent');
          document.getElementById('navbar').classList.add('navbar-shadow');*/
        } else {
          document.getElementById('navbar').classList.add('in-viewport');
          document.getElementById('navbar').classList.remove('out-of-viewport');
          /*document.getElementById('navbar').classList.add('bg-transparent');
          document.getElementById('navbar').classList.remove('bg-white');
          document.getElementById('navbar').classList.remove('navbar-shadow');*/
        }

        if (Math.abs(st - lastScrollTop) < 200) {
          return;
        }
        if (st > lastScrollTop) {
          var event = new CustomEvent("interaction:down-scroll");
          document.dispatchEvent(event);
        } else {
          var event = new CustomEvent("interaction:up-scroll");
          document.dispatchEvent(event);
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
      }, false);
    } else {
      this.#section.classList.remove('fixed-top');
      this.#section.classList.add('position-sticky', 'top-0');
    }
  }
}

export default Nav;